import { defineMessages } from "react-intl";

import {
	anamnesticAlcoholAbuseMessages,
	currentAlcoholAbuseMessages,
	currentAlcoholUseMessages,
	validator
} from "lib/build/forms/htx/risks/alcohol";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	alcohol: {
		id: "form.alcohol",
		defaultMessage: "Alkohol fogyasztás"
	},
	currentAlcoholUse: {
		id: "form.alcohol.current_alcohol_use",
		defaultMessage: "Aktuálisan fogyaszt alkoholt?"
	},
	currentAlcoholAbuse: {
		id: "form.alcohol.current_alcohol_abuse",
		defaultMessage: "Aktuálisan alkoholfüggőség gyanúja felmerül?"
	},
	anamnesticAlcoholAbuse: {
		id: "form.alcohol.anamnestic_alcohol_abuse",
		defaultMessage: "Anamnézisében szerepel alkoholfüggőség?"
	},
	summaryOfAlcoholUse: {
		id: "form.alcohol.summary_of_alcohol_use",
		defaultMessage: "Kezelőorvos megjegyzése"
	}
});

const fields: { [key: string]: FieldData } = {
	currentAlcoholUse: {
		type: "field",
		path: ["currentAlcoholUse"],
		label: messages.currentAlcoholUse,
		errorMessages: genericErrorMessages,
		input: {
			type: "button-group",
			props: { labels: currentAlcoholUseMessages }
		}
	},
	currentAlcoholAbuse: {
		type: "field",
		path: ["currentAlcoholAbuse"],
		label: messages.currentAlcoholAbuse,
		errorMessages: genericErrorMessages,
		input: {
			type: "button-group",
			props: { labels: currentAlcoholAbuseMessages }
		}
	},
	anamnesticAlcoholAbuse: {
		type: "field",
		path: ["anamnesticAlcoholAbuse"],
		label: messages.anamnesticAlcoholAbuse,
		errorMessages: genericErrorMessages,
		input: {
			type: "button-group",
			props: { labels: anamnesticAlcoholAbuseMessages }
		}
	},
	summaryOfAlcoholUse: {
		type: "field",
		path: ["summaryOfAlcoholUse"],
		label: messages.summaryOfAlcoholUse,
		errorMessages: genericErrorMessages,
		input: { type: "textarea", props: {} }
	}
};

const fieldset: FieldsetData = {
	rows: [
		{ columns: [{ width: 12, field: fields.currentAlcoholUse }] },
		{ columns: [{ width: 12, field: fields.currentAlcoholAbuse }] },
		{ columns: [{ width: 12, field: fields.anamnesticAlcoholAbuse }] },
		{ columns: [{ width: 12, field: fields.summaryOfAlcoholUse }] }
	]
};

export const node: LeafNode = {
	id: "alcohol",
	value: {
		title: messages.alcohol,
		validator,
		fieldset,
		isImportant: true,
		applyCurrentDate: true
	}
};
